import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import useGetUserInfo from "hooks/useGetUserInfo";
import useVersionCheck from "hooks/useVersionCheck";
import { AuthProvider } from "context/AuthContext";
import { DrawerProvider } from "context/DrawerContext";
// import ModalInstall from "components/ModalInstall";
import Drawer from "components/Drawer";
import InstallPWA from "components/InstallPWA";

function Root() {
  const { userId } = useGetUserInfo();
  const location = useLocation();
  
  // Hook pour vérifier automatiquement les mises à jour (déconnexion silencieuse)
  useVersionCheck();

  // TRACKER MIXPANEL - Enregistre chaque vue de page
  useEffect(() => {
    mixpanel.track("Page View", {
      "Page Path": location.pathname,
      "URL Complète": window.location.href,
    });
  }, [location.pathname]);

  return (
    <AuthProvider>
      <DrawerProvider>
        <div className="max-w-[500px] mx-auto overflow-hidden bg-gray-100 relative">
          {userId === 1340 ? (
            <div className="fixed top-0 w-full left-0 px-2 py-[1px] text-[8px] flex justify-center font-bold text-white bg-danger z-50 opacity-90">
              DEMO TEST
            </div>
          ) : null}
          <Outlet />
          <Drawer />
          {/* <ModalInstall
            opened={opened}
            onInstall={handleInstall}
            onClosed={() => setOpened(false)}
          /> */}
          <InstallPWA />
        </div>
      </DrawerProvider>
    </AuthProvider>
  );
}

export default Root;

